import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SignIn from './pages/auth/SignIn';
import SignUp from './pages/auth/SignUp';
import TradingTerminal from './pages/user/TradingTerminal';
import Home from './pages/user/Home';
import Profile from './pages/user/Profile';
import ChangePassword from './pages/user/ChangePassword';
import Documents from './pages/user/Documents';
import Deposit from './pages/user/Deposit';
import DepositSuccess from './pages/user/DepositSuccess';
import Withdrawal from './pages/user/Withdrawal';
import Credit from './pages/user/Credit';
import Transfer from './pages/user/Transfer';
import Statement from './pages/user/Statement';
import Analytics from './pages/user/Analytics';
import LeadCapture from './pages/public/LeadCapture';
import Landing from './pages/public/Landing';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import UserDetailPage from './pages/admin/UserDetailPage';
import AffiliateDetail from './pages/admin/AffiliateDetail';
import RetentionLead from './pages/admin/RetentionLead';
import ProtectedRoute from './components/common/ProtectedRoute';
import AdminRoute from './components/common/AdminRoute';
import BuyModal from './components/modals/BuyModal';
import SellModal from './components/modals/SellModal';
import OrderModal from './components/modals/OrderModal';

const AppRoutes = () => {
  return (
    <>
      <Routes>
        {/* Public Landing */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<SignIn />} />
        <Route path="/register" element={<SignUp />} />
        <Route path="/lead" element={<LeadCapture />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/terminal" element={<TradingTerminal />} />
          <Route path="/home" element={<Home />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/deposit" element={<Deposit />} />
          <Route path="/deposit/success" element={<DepositSuccess />} />
          <Route path="/withdrawal" element={<Withdrawal />} />
          <Route path="/credit" element={<Credit />} />
          <Route path="/transfer" element={<Transfer />} />
          <Route path="/statement" element={<Statement />} />
        </Route>
        <Route element={<AdminRoute />}>
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/user/:userId" element={<UserDetailPage />} />
          <Route path="/admin/affiliate/:affiliateId" element={<AffiliateDetail />} />
          <Route path="/admin/retention" element={<RetentionLead />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      <BuyModal />
      <SellModal />
      <OrderModal />
    </>
  );
};

export default AppRoutes;